export const environment = {
	appsettings: null,
};
